import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import { fCurrency } from '@/utils/formatNumber';
import useEventContext from '@/contexts/event/useEventContext';
import { usePromotionForm } from '@/sections/promotion';

function TicketPrice({ ticket, showDiscount = false }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const { max_price, ticket_type_id } = ticket;
  const {
    event: {
      preferences: { currency, fee_breakdown },
    },
  } = useEventContext();
  const { getItemDiscount } = usePromotionForm();
  const discount = showDiscount
    ? getItemDiscount(max_price, ticket_type_id)
    : 0;

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <Typography variant="body2" component="div">
      {max_price > 0 && (
        <>
          {show && discount > 0 && (
            <Typography
              component="span"
              variant="body2"
              sx={{
                color: (theme) => theme.palette.secondary.main,
                fontWeight: 600,
              }}
            >{`${fCurrency(discount)} ${currency} `}</Typography>
          )}
          <Typography
            component="span"
            variant="body2"
            sx={{
              textDecoration: discount > 0 ? 'line-through' : 'none',
            }}
          >{`${fCurrency(max_price)} ${currency} `}</Typography>
          <br />
          <Typography
            variant="caption2"
            sx={{ color: (theme) => theme.palette.grey[500] }}
          >
            {fee_breakdown === 'f' ? '' : t('checkout.home.cart.plusCharge')}
          </Typography>
        </>
      )}
      {max_price === 0 && `GRATIS `}
    </Typography>
  );
}

export default TicketPrice;
